// /orgs/$orgSlug/projects/$projectId/shots/$shotId/ — virtualized
// candidate grid + URL-driven filter sidebar (PRD §9.4 +
// docs/frontend_architecture.md §2 + B1f PR5, extended by B3d).
//
// Index child of the shot layout. The URL ↔ filter-state bridge:
//   * `validateSearch` lives on the PARENT layout route, so the typed
//     ShotSearch shape is inherited here via `Route.useSearch()`.
//   * `useNavigate()` writes a new shape back to the URL on every
//     sidebar change. Empty filters serialize to a bare URL (no
//     `?...`) because our custom `routerSearch.stringifySearch`
//     drops undefined / empty-array / false values.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ShotPage } from '../components/ShotPage';
import type { ShotSearch } from '../components/filters';

export const Route = createFileRoute(
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId/'
)({
  component: ShotIndexRoute,
});

function ShotIndexRoute(): React.JSX.Element {
  const { orgSlug, projectId, shotId } = Route.useParams();
  const filters = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onFiltersChange = (next: ShotSearch): void => {
    // `replace: true` so each filter tweak doesn't push a new history
    // entry — back-button would otherwise scroll through every
    // intermediate keystroke / chip add. The page itself is the
    // history entry; filter state lives inside that entry.
    void navigate({ search: next, replace: true });
  };

  return (
    <ShotPage
      orgSlug={orgSlug}
      projectId={projectId}
      shotId={shotId}
      filters={filters}
      onFiltersChange={onFiltersChange}
    />
  );
}
